<template>
	<el-tabs v-model="tagsactiveName" @tab-click="handleClick">
		<el-tab-pane class="topics-items" v-for="(b,index) in bigTagsList"
			:label="b.typeName + '   '+'('+ b.selectCount + ')'" :name="index+''">
			<!-- <el-button v-for="c in b.children" size=mini :plain="true">{{c.typeName}}</el-button> -->
			<span class="tag" :class="{'tag-active':item.select}" v-for="item,i in b.children"
				@click="tagClick(index,i)">{{item.typeName}}
				<!-- <img v-show="i<3" class="fire_img" src="../../static/images/preference/tagfire.png" alt=""> -->
			</span>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	export default{
		name:'tabsList',
		props:{
			bigTagsList:{
				type:Array,
				default:[],
			}
		},
		data(){
			return{
				tagsactiveName:0
			}
		},
		methods: {
			// sliderChange(e) {
			// 	this.showResult = e.detail.value
			// 	this.$emit('changing', e)
			// },
			//切换标签
			handleClick(tab, event) {
			        console.log(tab, event);
			},
			tagClick(index,i) {
				this.$set(this.bigTagsList[index].children[i], 'select', !this.bigTagsList[index].children[i].select)
				if(this.bigTagsList[index].children[i].select){
				  this.$set(this.bigTagsList[index], 'selectCount', this.bigTagsList[index].selectCount + 1)
				}else{
				  this.$set(this.bigTagsList[index], 'selectCount', this.bigTagsList[index].selectCount - 1)
				}
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.topics-items {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		margin-top: 10px;
		.tag {
			display: flex;
			padding: 3px 6px;
			color: #666;
			font-size: 13px;
			border: 1px solid #8d8d8d;
			border-radius: 8px;
			margin: 0 15px 15px 0;
			line-height: 26px;
			// img{
			// 	width: 20px;
			// 	height: 20px;
			// 	margin-left: 5px;
			// 	margin-right: -8px;
			// }
			&.tag-active {
				border: 1px solid rgb(254, 149, 0);
				color: rgb(254, 149, 0);
			}
		}
		.tag-active {
			border: 1px solid rgb(254, 149, 0);
			color: rgb(254, 149, 0);
		}
	}
</style>
